import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatOrderNumber(orderOrId) {
  if (!orderOrId) return '';

  if (typeof orderOrId === 'object') {
    if (orderOrId.order_number !== undefined && orderOrId.order_number !== null) {
      return String(orderOrId.order_number).padStart(4, '0');
    }
    orderOrId = orderOrId.id;
  }

  const raw = String(orderOrId);
  const firstPart = raw.split('-')[0] || raw.slice(0, 8);
  const hexPart = firstPart.replace(/[^0-9a-f]/gi, '').slice(0, 8);

  if (hexPart.length >= 4) {
    return String(parseInt(hexPart, 16)).slice(0, 8);
  }

  const digits = raw.replace(/\D/g, '');
  return digits ? digits.slice(0, 8) : raw.slice(0, 8).toUpperCase();
}

export function getOrderItemCount(order) {
  return (order?.items || []).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
}
